import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import { CONTACT } from "@/data/content";

export const CTASection = ({
  title = "Ready for a little more brightness?",
  text = "Book a free, no-pressure consultation. We'll listen first, then suggest the kindest next step — even if that isn't us.",
}) => (
  <section className="px-4 pb-24 pt-8 sm:px-6 lg:px-8" data-testid="cta-section">
    <Reveal>
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-forest px-6 py-16 sm:px-12 sm:py-20 lg:px-20">
        <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-terracotta/25 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-sage/30 blur-3xl" />
        <div className="relative max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-terracotta-soft">Free consultation · No obligation</p>
          <h2 className="mt-4 font-serif text-3xl tracking-tight text-linen sm:text-4xl lg:text-5xl">{title}</h2>
          <p className="mt-5 text-base leading-relaxed text-linen/70 sm:text-lg">{text}</p>
          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center">
            <Button
              asChild
              data-testid="cta-book-button"
              className="group rounded-full bg-terracotta px-7 py-6 text-base text-linen shadow-[0_12px_30px_rgba(200,109,81,0.35)] transition-colors duration-300 hover:bg-terracotta-deep"
            >
              <Link to="/contact">
                Book a free consultation
                <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
            <a
              data-testid="cta-email-link"
              href={`mailto:${CONTACT.email}`}
              className="inline-flex items-center gap-2 text-sm font-medium text-linen/80 transition-colors hover:text-terracotta-soft"
            >
              <Mail className="h-4 w-4" /> {CONTACT.email}
            </a>
            <span data-testid="cta-phone" className="text-sm font-medium text-linen/80">
              Call us: {CONTACT.phone} <span className="text-linen/50">(Mon–Fri, 9am–5pm)</span> · Evenings & weekends: {CONTACT.mobile}
            </span>
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);
